export default {"src":"/_next/static/media/8.f9db45ff.svg","height":140,"width":119,"blurWidth":0,"blurHeight":0};